import useApiService from "./useApiService";

const useNews = () => {
  const { get, post, del } = useApiService();

  const fetchAllNews = async () => {
    try {
      const response = await get("/api/news");
      if (response.status && response.data) {
        const { data } = response;
        return {
          news: data.map((news) => ({
            id: news.id,
            content: news.content,
            title: news.title,
            photo_id: news.photo?.id,
            photo_url: news.photo?.url,
          })),
        };
      } else {
        throw new Error("Unable to fetch news");
      }
    } catch (error) {
      return { error };
    }
  };

  const addNewNews = async (newsData) => {
    try {
      const response = await post("/api/news", newsData);
      if (response.status && response.data) {
        return { success: "News added successfully" };
      } else {
        throw new Error("Unable to add new news");
      }
    } catch (error) {
      return { error };
    }
  };

  const deleteNews = async (id) => {
    try {
      const response = await del(`/api/news/${id}`);
      if (response.status) {
        return { success: "News deleted successfully" };
      } else {
        throw new Error("Unable to delete news");
      }
    } catch (error) {
      return { error: error.message };
    }
  };

  return { fetchAllNews, addNewNews, deleteNews };
};

export default useNews;
